import io from 'socket.io-client'
import Cookies from 'js-cookie'
import toast from 'utils/toast'

const { REACT_APP_API_ENDPOINT } = process.env
const MAX_RECONNECTION_ATTEMPTS = 10

const getURL = () => Cookies.get('tenantUrl')

export const connectToSocket = ({ path, eventsCallback = [], onConnected }) => {
  const url = getURL()
  if (!url) {
    toast({ title: 'Invalid socket URL', type: 'error' })
    console.error('[Socket] Invalid URL from cookie')
    return null
  }

  const socket = io(url, {
    transports: ['websocket'],
    secure: true,
    path: `${REACT_APP_API_ENDPOINT}${path}`,
    reconnection: true,
    reconnectionAttempts: MAX_RECONNECTION_ATTEMPTS,
    reconnectionDelay: 500,
    reconnectionDelayMax: 1000,
    randomizationFactor: 0,
  })

  const bindEvents = () => {
    eventsCallback.forEach(({ event, callback }) => {
      socket.off(event)
      socket.on(event, (...args) => {
        console.log(`[Socket] Event received: ${event}`, args)
        callback(args[0])
      })
    })
  }

  socket.on('connect', () => {
    console.log('[Socket] Connected:', socket.id)
    onConnected?.(socket)
    bindEvents()
  })

  socket.on('reconnect', attempt => {
    console.log('[Socket] Reconnected after attempt:', attempt)
    bindEvents()
  })

  socket.on('disconnect', reason => {
    console.warn('[Socket] Disconnected:', reason)
  })

  socket.on('reconnect_attempt', attempt => {
    console.warn('[Socket] Reconnect attempt:', attempt)
    if (attempt === MAX_RECONNECTION_ATTEMPTS) {
      toast({
        title:
          'Could not connect to websocket server. Please refresh and try again.',
        type: 'error',
        time: 'normal',
      })
    }
  })

  socket.on('connect_error', error => {
    console.error('[Socket] Connection error:', error)
  })

  return socket
}

export const disconnectFromSocket = socket => {
  if (socket?.connected || socket?.connecting) {
    socket.disconnect()
    console.log('[Socket] Disconnected manually')
  }
}
